import clsx from "clsx"
import { marked } from "marked"
import { npPagePxClassName, npSectionMtClassName } from "src/components/np-design/components/constants"

export type NpMarkdownSectionProps = {
  markdown: string
  align: "left" | "center" | "right" | undefined
  standalone?: boolean
}

export const NpMarkdownSection = ({ markdown, align, standalone = true }: NpMarkdownSectionProps) => {
  return (
    <section
      className={clsx(standalone && npSectionMtClassName, npPagePxClassName, {
        "text-left": !align || align === "left",
        "text-center": align === "center",
        "text-right": align === "right",
      })}
    >
      <div className="RichText" dangerouslySetInnerHTML={{ __html: marked(markdown || "") }} />
    </section>
  )
}
